
import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { useReactToPrint } from "react-to-print";
import { Search } from 'lucide-react';
import classes from "./TrialBalance.module.css";
import plus from "../../../Assets/plus.svg"
import ReportBackground from "../../../Assets/report.svg"
import run from "../../../Assets/run.svg"
import MailLogo from "../../../Assets/mail.svg"
import PrintLogo from "../../../Assets/print.svg"
import DownloadLogo from "../../../Assets/down.svg"
import ExcelLogo from "../../../Assets/excel.png"
import PdfLogo from "../../../Assets/pdf.png"
import BackLogo from "../../../Assets/back.svg"
import RotatingLogo from '../../../Assets/rotating-logo.png'
import EyeIcon from "../../../Assets/new-eye.svg"
import DeleteIcon from "../../../Assets/new-delete.svg"
import PencilIcon from "../../../Assets/pencil.svg"
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { Spinner, Badge, Button, Modal, Form } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';

import axios from "axios";
import { BASE_URL } from "../../../Components/Styles/API/API";
import { useLocation, useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import download from "../../../Assets/download1.svg"
import upload from "../../../Assets/upload.svg"
import logo from "../../../Assets/rotating-logo.png";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import HeaderNav from "../../Budget/Budget Dashboard/HeaderNav/HeaderNav";
import * as XLSX from 'xlsx'; // Import xlsx library
import { saveAs } from 'file-saver';
import jsPDF from "jspdf";
import "jspdf-autotable";


const TrialBalance = () => {
  const location = useLocation();
  const [noData, setNoData] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectOptions, setSelectOptions] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [load, setLoad] = useState(false);
  const [tableData3, setTableData3] = useState([]);
  const [tableData4, setTableData4] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState('');
  const [selectedRegion, setSelectedRegion] = useState('');
  const [selectedContinent, setSelectedContinent] = useState('');
  const [tableData45, setTableData45] = useState([]);
  const [totalDebit, setTotalDebit] = useState('');
  const [totalCredit, setTotalCredit] = useState('');
  const [allAccounts, setAllAccounts] = useState([]);
  const [fetchingLoading, setFetchingLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedBank, setSelectedBank] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [searchedResult, setSearchedResult] = useState([]);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [bearer, setBearer] = useState('');
  const [user, setUser] = useState('');
  const [error, setError] = useState(null);
  const [entriesPerPage, setEntriesPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalEntries, setTotalEntries] = useState("");
  const [loanCode, setLoanCode] = useState("");
  const [loanDescription, setLoanDescription] = useState("");
  const [selectedReportTo, setSelectedReportTo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [savingsLoading, setSavingsLoading] = useState(false);
  const [show1, setShow1] = useState(false);
  const [cashbook, setCashbook] = useState([]);
  const [tableData, setTableData] = useState([]);
  const navigate = useNavigate();
  const [benLoading, setBenLoading] = useState(false);
  const [statLoading, setStatLoading] = useState(false);
  const [stat, setStat] = useState([]);
  const [currentMonth, setCurrentMonth] = useState("");
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedEndDate, setSelectedEndDate] = useState('');
  const [inputss, setInputss] = useState([]);
  const [loadings, setLoadings] = useState(false);
  const [continent, setContinent] = useState('');
  const [region, setRegion] = useState('');
  const [province, setProvince] = useState('');
  const [admin, setAdmin] = useState('');
  const [usert, setUsert] = useState("");
  const [totalClosing, setTotalClosing] = useState('');
  const [totalOpening, setTotalOpening] = useState('');

  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');
      const current = await localStorage.getItem('currentMonth');
      const admins = await localStorage.getItem('admin');
      // const saved = localStorage.getItem("cashbook_preview");
      const continentName = await localStorage.getItem('continent');
      const regionName = await localStorage.getItem('region');
      const provinceName = await localStorage.getItem('province');
      const provinceid = await localStorage.getItem('provinceID');
      const continentid = await localStorage.getItem('continentID');
      const regionid = await localStorage.getItem('regionID');
      const usertype = await localStorage.getItem('userType');

      if (value !== null) {
        setBearer(value);
      }
      if (continentName !== null) {
        setContinent(continentName);
      }
      // if (regionName !== null) {
      //   setRegion(regionName);
      // }
      if (provinceName !== null) {
        setProvince(provinceName);
      }
      // if (provinceid !== null) {
      //   setSelectedProvince(provinceid);
      // }

      // if (continentid !== null) {
      //   setSelectedContinent(continentid);
      // }
      // if (regionid !== null) {
      //   setSelectedRegion(regionid);
      // }
      if (usertype !== null) {
        setUsert(usertype);
      }
      // if (saved) {
      //   setCashbook(JSON.parse(saved));
      // }

      if (value1 !== null) {
        setUser(value1);
      }
      if (current !== null) {
        console.log(current);
        const date = new Date(current);

        setCurrentMonth(date);

        const startOfDateRange = new Date(1900, 0, 1);

        const endOfDateRange = new Date(date.getFullYear(), date.getMonth() + 1, 0);

        // Format date function as 'YYYY-MM-DD'
        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };

        setMinDate(formatDate(startOfDateRange));
        setMaxDate(formatDate(endOfDateRange));

        console.log("Date Range:", formatDate(startOfDateRange), "to", formatDate(endOfDateRange));
      }
      if (admins !== null) {
        setAdmin(admins);
      }
      if (continentName !== null) {
        setContinent(continentName);
      }
      if (regionName !== null) {
        setRegion(regionName);
      }
      if (provinceName !== null) {
        setProvince(provinceName);
      }
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };







  const handleShow1 = (loan) => {
    setLoanCode(loan.code);
    setLoanDescription(loan.description);
    setSelectedReportTo(loan.reportTo);
    setShow1(true);
  };

  const handleClose1 = () => setShow1(false);


  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const handleCustomers = async () => {
    setBenLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/fetch-pending-sales-invoice-paginated?page=${currentPage}`, { headers });
      const results = response.data?.data?.data;
      const resultx = response.data?.data?.total;
      setTotalEntries(resultx);
      setTableData(results);
      console.log(results, "From Remittane")
      const total = response.data?.data?.last_page || 1;
      setTotalPages(total);

    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response?.data && error.response?.data.message) {
          if (typeof error.response?.data.message === 'string') {
            errorMessage = error.response?.data.message;
          } else if (Array.isArray(error.response?.data.message)) {
            errorMessage = error.response?.data.message.join('; ');
          } else if (typeof error.response?.data.message === 'object') {
            console.log(errorMessage);
            setError(errorMessage)
          }
        }
        setTableData([]);
      }
    } finally {
      setBenLoading(false);
    }

  };

  useEffect(() => {
    if (bearer) {
      handleCustomers();
    }
  }, [bearer, currentPage]);

  // const fetchAccounts = async () => {
  //   setSavingsLoading(true);
  //   try {
  //     const response = await axios.get(`${BASE_URL}/reports/get-trial-balance`, {
  //       params: {
  //         // gl_code: selectedBank?.value || "",
  //         start_date: selectedDate,
  //         end_date: selectedEndDate,
  //         continent_id: selectedContinent || "",
  //         region_id: selectedRegion || "",
  //         province_id: selectedProvince || ""
  //       },
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Authorization': `Bearer ${bearer}`
  //       }
  //     });

  //     if (!response.data?.data?.journal || response.data?.data?.journal.length === 0) {
  //       setAccounts([]);   // ✅ clear previous data
  //       setNoData(true);
  //       return;
  //     }

  //     const resultsss = response.data?.data?.journal;
  //     const resultssx = response.data?.data?.input;

  //     setAccounts(resultsss);
  //     setInputss(resultssx);
  //     setNoData(false);

  //     console.log(resultsss);

  //   } catch (error) {
  //     if (error.response && error.response.status === 401) {
  //       navigate('/login');
  //     } else {
  //       console.log(error);
  //       setAccounts([]);   // ✅ also clear here on error
  //       setNoData(true);
  //     }
  //   } finally {
  //     setSavingsLoading(false);
  //   }
  // };

  const fetchAccounts = async () => {
    setInputss([]);
    setSavingsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/reports/get-trial-balance`, {
        params: {
          // gl_code: selectedAccount,
          // start_date: selectedDate,
          // end_date: selectedEndDate,
          // continent_id: usert == '2' ? selectedContinent : selectedContinent || "",
          // region_id: usert == '3' ? regio : selectedRegion || "",
          // province_id: usert == '4' ? provin : selectedProvince || ""
          start_date: selectedDate,
          end_date: selectedEndDate,
          continent_id: selectedContinent || "",
          region_id: selectedRegion || "",
          province_id: selectedProvince || ""
        },
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${bearer}`
        }
      });
      const resultsss = response.data?.data;
      setAccounts(resultsss);

      const resultssx = response.data?.data?.values;
      setInputss(resultssx);
      console.log(response);

    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      } else {
        const errorStatus = error.response?.data?.message;
        console.log(errorStatus);

      }
    } finally {
      setSavingsLoading(false);
    }
  };




  // const filteredAccounts = accounts.filter((item) => {
  //   const term = searchTerm.toLowerCase();
  //   return (
  //     item.details?.toLowerCase().includes(term) ||
  //     item.cheque_number?.toLowerCase().includes(term) ||
  //     item.transaction_date?.toLowerCase().includes(term)
  //   );
  // });


  const fetchAccountss = async () => {
    console.log(headers)
    setLoadings(true);

    try {
      const response = await axios.get(`${BASE_URL}/account/cash-and-bank`, { headers });

      const CustomOption = (props) => {
        const { data, innerRef, innerProps } = props;
        return (
          <div ref={innerRef} {...innerProps}>
            <span style={{ color: 'blue' }}>{data?.gl_code}</span>
            {' - '}
            <span style={{ color: 'red', fontWeight: 'bold' }}>{data?.gl_name}</span>
          </div>
        );
      };

      const allAccts = response.data?.data;
      const opt1 = allAccts.map((item) => ({
        label: `${item.gl_code} - ${item.gl_name}`,
        value: item.id,
      }));
      setAllAccounts(opt1);

      //   console.log(allAccts, "All Accounts");
    } catch (error) {
      const errorStatus = error.response?.data.message;
      console.error(errorStatus);
    } finally {
      setLoadings(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchAccountss();
    }
  }, [bearer]);





  function formatDates(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())}`;
    return formattedDate;
  }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }

  const handlePrevPage = () => {
    setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
  };

  const formattedTotalEntries = totalEntries.toLocaleString();

  const fetchStat = async () => {
    setStatLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/customer/total-customers`, { headers });
      const stas = response.data?.data;

      setStat(stas);

    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            console.log(errorMessage);
          }
        }
        setStat([]);
      }
    } finally {
      setStatLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchStat();

    }
  }, [bearer]);

  const formatStat = (value) => {
    if (value == null) return "";

    if (value >= 1000 && value < 1000000) {
      const rounded = value / 1000;
      // If divisible by 1000 exactly, no decimals (30k)
      if (value % 1000 === 0) {
        return `${rounded}k`;
      }
      // Else show 2 decimals (30.01k)
      return `${rounded.toFixed(2)}k`;
    }

    if (value >= 1000000) {
      const rounded = value / 1000000;
      if (value % 1000000 === 0) {
        return `${rounded}M`;
      }
      return `${rounded.toFixed(2)}M`;
    }

    // smaller than 1000 → just locale string with commas
    return value.toLocaleString("en-US");
  };

  const isSearching = searchTerm.trim() !== "" && searchedResult.length > 0;
  const handleDateChange1 = (event) => {
    setSelectedEndDate(event.target.value);
  };

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  const handleBank = (selectedOption) => {
    setSelectedBank(selectedOption);
  };

  const handleCreate = () => {

  }

  const fetchContinents = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/continents`, { headers });
      const results = response.data?.data;

      const options = results.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      // setCustomers(results);
      setSelectOptions(options);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setCustomers([]);
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    if (bearer) {
      fetchContinents();
    }
  }, [bearer]);



  const fetchSubContinents = async () => {
    setLoad(true);
    try {
      const response = await axios.get(`${BASE_URL}/continents/getcontinentregions?continent_id=${selectedContinent}`, { headers });

      // console.log(response);
      const subCont = response.data?.data;
      const options1 = subCont.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setTableData3(options1);
      // console.log(results);
    } catch (error) {
      // if (error.response && error.response.status === 401) {
      //   // Redirect to login page if unauthorized
      //   navigate('/login');
      // } else {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }
      setTableData3([]);
      // }
    } finally {
      setLoad(false);
    }
  };

  const fetchSubRegion = async () => {
    setLoad(true);
    try {
      const response = await axios.get(`${BASE_URL}/regions/getprovincesregion?region_id=${selectedRegion}`, { headers });

      // console.log(response);
      const subCont1 = response.data?.data;
      const options2 = subCont1.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setTableData4(options2);
      console.log(options2);
    } catch (error) {
      // if (error.response && error.response.status === 401) {
      //   // Redirect to login page if unauthorized
      //   navigate('/login');
      // } else {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }
      setTableData3([]);
      // }
    } finally {
      setLoad(false);
    }
  };
  const fetchProvince = async () => {
    setLoad(true);
    try {
      const response = await axios.get(`${BASE_URL}/provinces`, { headers });

      // console.log(response);
      const subCont15 = response.data?.data.provinces;
      const options25 = subCont15.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setTableData45(options25);
      console.log(response);
    } catch (error) {
      // if (error.response && error.response.status === 401) {
      //   // Redirect to login page if unauthorized
      //   navigate('/login');
      // } else {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }
      setTableData3([]);
      // }
    } finally {
      setLoad(false);
    }
  };

  useEffect(() => {
    if (bearer && selectedContinent) {
      fetchSubContinents(selectedContinent);
    }
  }, [bearer, selectedContinent]);

  useEffect(() => {
    if (bearer && selectedRegion) {
      fetchSubRegion(selectedRegion);
    }
  }, [bearer, selectedRegion]);

  useEffect(() => {
    if (bearer) {
      fetchProvince();
    }
  }, [bearer]);

  const handleContinentChange = (selectedOption) => {
    setSelectedContinent(selectedOption.value);
    setSelectedRegion('');
    setSelectedProvince('');
  };


  const handleRegionChange = (selectedOption) => {
    setSelectedRegion(selectedOption.value)
  }

  const handleProvinceChange = (selectedOption) => {
    setSelectedProvince(selectedOption.value)
  }


  function formatDate(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())} ${padZero(date.getHours())}:${padZero(date.getMinutes())} ${date.getHours() >= 12 ? 'PM' : 'AM'}`;
    return formattedDate;
  }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }

  // useEffect(() => {
  //   if (accounts) {
  //     const debitTotal = accounts?.reduce((total, item) => total + parseFloat(item.debit), 0);
  //     const creditTotal = accounts?.reduce((total, item) => total + parseFloat(item.credit), 0);

  //     // Format the numbers with commas and two decimal places
  //     const formattedDebitTotal = debitTotal?.toLocaleString('en-US', {
  //       minimumFractionDigits: 2,
  //       maximumFractionDigits: 2
  //     });
  //     const formattedCreditTotal = creditTotal?.toLocaleString('en-US', {
  //       minimumFractionDigits: 2,
  //       maximumFractionDigits: 2
  //     });

  //     setTotalDebit(formattedDebitTotal);
  //     setTotalCredit(formattedCreditTotal);
  //   }
  // }, [accounts]);

  useEffect(() => {
    if (inputss) {
      const creditTotal = inputss
        .filter((item) => !isNaN(item.nCredit) && item.nCredit !== "")
        .reduce((total, item) => total + parseFloat(item.nCredit), 0);

      const debitTotal = inputss
        .filter((item) => !isNaN(item.nDebit) && item.nDebit !== "")
        .reduce((total, item) => total + parseFloat(item.nDebit), 0);


      const openingTotal = inputss
        .filter((item) => !isNaN(item.opening_balance) && item.opening_balance !== "")
        .reduce((total, item) => total + parseFloat(item.opening_balance), 0);

      const closingTotal = inputss
        .filter((item) => !isNaN(item.closing_balance) && item.closing_balance !== "")
        .reduce((total, item) => total + parseFloat(item.closing_balance), 0);
      // Format the numbers with commas and two decimal places
      const formattedDebitTotal = debitTotal.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      const formattedOpeningTotal = openingTotal.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      const formattedClosingTotal = closingTotal.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      const formattedCreditTotal = creditTotal.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      setTotalDebit(formattedDebitTotal);
      setTotalCredit(formattedCreditTotal);
      setTotalOpening(formattedOpeningTotal);
      setTotalClosing(formattedClosingTotal);
    }
  }, [inputss]);

  const tableRef = useRef(null);


  const handlePrint = () => {

    setTimeout(() => {
      window.print();
    }, 100);
  };

  const exportToExcel = async () => {
    // Fetch all data (not just current page)
    const dataToExport = inputss;

    if (!dataToExport || dataToExport.length === 0) {
      console.log("No data available to export");
      return;
    }
    console.log("Fetched Data:", dataToExport);

    const formatDate = (date) =>
      date
        ? new Date(date).toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
          })
        : "--";
  
    const name = accounts?.name || "Trial Balance Report";
    const startDate = formatDate(accounts?.start_date);
    const endDate = formatDate(accounts?.end_date);
  
    console.log("Fetched Data:", dataToExport);

    const excelRows = [];

    // Header section
    excelRows.push([name]); // Report name
    excelRows.push([
      `Trial Balance Report between the period of ${startDate} to ${endDate}`,
    ]);
    excelRows.push([]); // Empty row for spacing
  
    // Table header
    excelRows.push([
      "S/N",
      "Account Code",
      "Account Name",
      "Type",
      "Beginning Balance",
      "Debit",
      "Credit",
      "Ending Balance",
    ]);
  
    // Data rows
    dataToExport.forEach((item, index) => {
      excelRows.push([
        index + 1,
        item.code || "",
        item.name || "",
        item.type || "",
        item.opening_balance || 0,
        item.nDebit || 0,
        item.nCredit || 0,
        item.closing_balance || 0,
      ]);
    });
  
    // ====== Create worksheet ======
    const worksheet = XLSX.utils.aoa_to_sheet(excelRows);
  
    // Adjust column widths
    worksheet["!cols"] = [
      { wch: 5 },   // S/N
      { wch: 15 },  // Account Code
      { wch: 30 },  // Account Name
      { wch: 15 },  // Type
      { wch: 20 },  // Beginning Balance
      { wch: 15 },  // Debit
      { wch: 15 },  // Credit
      { wch: 20 },  // Ending Balance
    ];
  
    // ====== Create and save workbook ======
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Trial Balance Report");
  
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const file = new Blob([excelBuffer], { type: "application/octet-stream" });
    // Trigger download
    saveAs(file, 'TrialBalanceReport.xlsx');
  };

  const exportToPDF = () => {
    const dataToExport = inputss;
    const dataToExport2 = accounts;

    if (!dataToExport || dataToExport.length === 0) {
      console.log("No data available to export");
      return;
    }

    const doc = new jsPDF("p", "mm", "a4");
    const pageWidth = doc.internal.pageSize.getWidth();

    //   // --- Header Section ---
    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.text("The Redeemed Christian Church Of God", pageWidth / 2, 15, {
      align: "center",
    });

    doc.setFont("helvetica", "normal");
    doc.setFontSize(13);
    doc.text(dataToExport2?.name || "", pageWidth / 2, 23, {
      align: "center",
    });

    doc.setFontSize(11);
    const startDate = dataToExport2?.start_date
      ? new Date(dataToExport2.start_date).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
      : "--";

    const endDate = dataToExport2?.end_date
      ? new Date(dataToExport2.end_date).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
      : "--";

    doc.text(
      `Trial Balance Report between the period of ${startDate} to ${endDate}`,
      pageWidth / 2,
      30,
      { align: "center" }
    );
    // // ✅ Title
    // doc.setFontSize(16);
    // doc.text("Trial Balance Report", pageWidth / 2, 15, { align: "center" });

    // ✅ Opening Balance Header Section
    const openingBalance = parseFloat(accounts?.[0]?.opening_balance || 0).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    doc.setFontSize(12);
    doc.setTextColor(59, 130, 246); // blue
    doc.text(`Opening Balance: ${openingBalance}`, 14, 25);

    // ✅ Table Headers
    const columns = [
      { header: "S/N", dataKey: "sn" },
      { header: "Account Code", dataKey: "code" },
      { header: "Account Name", dataKey: "name" },
      { header: "Type", dataKey: "type" },
      { header: "Beginning Balance", dataKey: "opening_balance" },
      { header: "Debit", dataKey: "nDebit" },
      { header: "Credit", dataKey: "nCredit" },
      { header: "Ending Balance", dataKey: "closing_balance" },
    ];

    // ✅ Table Rows
    const rows = dataToExport.map((item, index) => ({
      sn: index + 1,
      code: item.code || "",
      name: item.name || "",
      type: item.type || "",
      opening_balance: (parseFloat(item.opening_balance) || 0).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      nDebit: (parseFloat(item.nDebit) || 0).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      nCredit: (parseFloat(item.nCredit) || 0).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      closing_balance: (parseFloat(item.closing_balance) || 0).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
    }));

    // ✅ Totals Row (footer)
    const totalRow = {
      sn: "",
      code: "",
      name: "TOTALS",
      type: "",
      opening_balance: totalOpening,
      nDebit: totalDebit,
      nCredit: totalCredit,
      closing_balance: totalClosing,
    };

    rows.push(totalRow);

    // ✅ Generate the Table
    doc.autoTable({
      columns,
      body: rows,
      startY: 32,
      styles: { fontSize: 8, cellPadding: 3 },
      headStyles: { fillColor: [0, 51, 102], textColor: 255, fontSize: 9 },
      alternateRowStyles: { fillColor: [245, 245, 245] },
      columnStyles: {
        name: { cellWidth: 40 },
        type: { cellWidth: 25 },
        opening_balance: { halign: "right" },
        nDebit: { halign: "right" },
        nCredit: { halign: "right" },
        closing_balance: { halign: "right" },
      },
      didDrawPage: (data) => {
        // ✅ Footer: date + page number
        const pageCount = doc.internal.getNumberOfPages();
        const pageSize = doc.internal.pageSize;
        const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();

        doc.setFontSize(10);
        doc.setTextColor(100);
        doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, pageHeight - 10);
        doc.text(`Page ${data.pageNumber} of ${pageCount}`, pageWidth - 30, pageHeight - 10);
      },
    });

    doc.save("TrialBalanceReport.pdf");
  };




  return (
    <div style={{ backgroundColor: "#f9f9f9", minHeight: "100vh" }}>
      <HeaderNav />

      <div className={classes.topContainer}>
        <div className={classes.backTxt}>
          <img src={BackLogo} alt="back" className={classes.iconBtn} onClick={() => console.log("icon3")} />
          <div className={classes.bckText}>
            <h3 className={classes.topText}>Trial Balance</h3>
          </div>
        </div>

        <div style={{ marginTop: 12 }} />
        <div className={classes.topNavBars}>
          <div className={classes.filterRow}>
            {/* Left side: Inputs */}
            <div className={classes.filterInputs}>
              {/* Account */}
              <div className={classes.inlineField}>
                {/* <label className={classes.inlineLabel}>Account:</label> */}
                {/* <Select
                  onChange={handleBank}
                  options={allAccounts}
                  menuPortalTarget={document.body}
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      width: 200, // ✅ fixed width
                      fontSize: 12, // applies to the wrapper
                    }),
                    control: (provided) => ({
                      ...provided,
                      minHeight: "36px",
                      fontSize: 12, // ✅ font size inside control
                    }),
                    singleValue: (provided) => ({
                      ...provided,
                      fontSize: 12, // ✅ selected value text
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      fontSize: 12, // ✅ dropdown option text
                      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                      color: "#111827",
                    }),
                    menu: (provided) => ({
                      ...provided,
                      maxHeight: "300px",
                      maxWidth: "200px",
                      overflowY: "auto",
                      fontSize: 12, // ✅ font size in menu
                    }),
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  className={classes.inlineSelect}
                /> */}

              </div>
              <div className={classes.inlineField}>
                <label className={classes.inlineLabel}>Continent:</label>
                <Select
                  onChange={handleContinentChange}        // was handleBank
                  options={selectOptions}                 // now populated from getcontinentregions?continent_id=23
                  menuPortalTarget={document.body}
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      width: 200,
                      fontSize: 12,
                    }),
                    control: (provided) => ({
                      ...provided,
                      minHeight: "36px",
                      fontSize: 12,
                    }),
                    singleValue: (provided) => ({
                      ...provided,
                      fontSize: 12,
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      fontSize: 12,
                      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                      color: "#111827",
                    }),
                    menu: (provided) => ({
                      ...provided,
                      maxHeight: "300px",
                      maxWidth: "200px",
                      overflowY: "auto",
                      fontSize: 12,
                    }),
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  className={classes.inlineSelect}
                />

              </div>
              <div className={classes.inlineField}>
                <label className={classes.inlineLabel}>Region:</label>
                <Select
                  onChange={handleRegionChange}          // calls fetchSubRegion -> populates provinces (tableData4)
                  options={tableData3}                   // provinces for selected region
                  menuPortalTarget={document.body}
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      width: 200,
                      fontSize: 12,
                    }),
                    control: (provided) => ({
                      ...provided,
                      minHeight: "36px",
                      fontSize: 12,
                    }),
                    singleValue: (provided) => ({
                      ...provided,
                      fontSize: 12,
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      fontSize: 12,
                      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                      color: "#111827",
                    }),
                    menu: (provided) => ({
                      ...provided,
                      maxHeight: "300px",
                      maxWidth: "200px",
                      overflowY: "auto",
                      fontSize: 12,
                    }),
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  className={classes.inlineSelect}
                />

              </div>
              <div className={classes.inlineField}>
                <label className={classes.inlineLabel}>Province:</label>
                <Select
                  onChange={
                    handleProvinceChange
                  }
                  options={tableData4} // if you already populate tableData45 elsewhere, keep; otherwise you may want to set this to tableData4 depending on desired cascading
                  menuPortalTarget={document.body}
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      width: 200,
                      fontSize: 12,
                    }),
                    control: (provided) => ({
                      ...provided,
                      minHeight: "36px",
                      fontSize: 12,
                    }),
                    singleValue: (provided) => ({
                      ...provided,
                      fontSize: 12,
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      fontSize: 12,
                      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
                      color: "#111827",
                    }),
                    menu: (provided) => ({
                      ...provided,
                      maxHeight: "300px",
                      maxWidth: "200px",
                      overflowY: "auto",
                      fontSize: 12,
                    }),
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  className={classes.inlineSelect}
                />

              </div>
              {/* Start Date */}
              <div className={classes.inlineField}>
                <label className={classes.inlineLabel}>Start Date:</label>
                <input
                  className="form-control"
                  type="date"
                  onChange={handleDateChange}
                  value={selectedDate}
                  style={{ fontSize: 14 }}
                  // min={minDate}
                  // max={maxDate}
                  required
                />
              </div>

              {/* End Date */}
              <div className={classes.inlineField}>
                <label className={classes.inlineLabel}>End Date:</label>
                <input
                  className="form-control"
                  type="date"
                  onChange={handleDateChange1}
                  value={selectedEndDate}
                  // min={minDate}
                  style={{ fontSize: 14 }}
                  // max={maxDate}
                  required
                />
              </div>
              <button className={classes.loanBtn} onClick={fetchAccounts}> <img src={run} alt="run-report" /> Run Report </button>
            </div>

            {/* Right side: 3 icons */}

          </div>


        </div>
        <div style={{ marginTop: 24 }} />

        <div className={classes.tableContainer}>
          {accounts.length === 0 ? (
            <div
              style={{
                textAlign: "center",
                padding: "40px",
                fontSize: "18px",
                color: "#374151",
              }}
            >
              <p>No data to display</p>
            </div>
          ) : (
            <>
              <div className={classes.sideTools}>
                {inputss.length > 0 && (
                  <div className={classes.filterIcons}>
                    <img
                      src={MailLogo}
                      alt="icon1"
                      className={classes.iconBtns}
                      onClick={() => console.log("icon1")}
                    />
                    <img
                      onClick={() => handlePrint()}
                      src={PrintLogo}
                      alt="icon2"
                      className={classes.iconBtns}
                    />
                    <img
                      src={DownloadLogo}
                      alt="icon3"
                      className={classes.iconBtns}
                      onClick={() => console.log("icon3")}
                    />
                    {/* <img
                      src={DownloadLogo}
                      alt="icon3"
                      className={classes.iconBtns}
                      onClick={() => console.log("icon3")}
                    /> */}
                    <img
                      onClick={() => exportToExcel()}
                      src={ExcelLogo}
                      alt="icon3"
                      className={classes.iconBtns}
                    />
                    <img
                      onClick={() => exportToPDF()}
                      src={PdfLogo}
                      alt="icon3"
                      className={classes.iconBtns}
                    />
                  </div>
                )}
              </div>

              <div className={classes.cntrTable}>
                <h1 className={classes.cntrTxt}>
                  The Redeemed Christian Church Of God
                </h1>
                <p className={classes.cntrTxt12}>{accounts?.name}</p>
                <p className={classes.cntrTx122}>Trial Balance Report
                  between the period of {" "} {accounts?.start_date
                    ? new Date(accounts?.start_date).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })
                    : "--"} to {" "}
                  {accounts?.end_date
                    ? new Date(accounts?.end_date).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })
                    : "--"}
                </p>
              </div>

              {/* ✅ Insert the table here */}
              <table style={{ width: "100%", borderCollapse: "collapse", marginTop: 20 }}>
                <thead>
                  <tr style={{ borderBottom: "1px solid #d1d5db", }}>
                    <th
                      colSpan={5}
                      style={{
                        textAlign: "left",
                        color: "#3B82F6",
                        fontWeight: 700,
                        fontSize: 18,
                        padding: "8px",

                      }}
                    >
                      Opening Balance
                    </th>
                    <th></th>
                    <th
                      style={{
                        textAlign: "right",
                        color: "#3B82F6",
                        fontWeight: 700,
                        fontSize: 18,
                        padding: "8px",
                      }}
                    >
                      {/* <div style={{display:  'flex', alignItems: "flex-end", justifyContent: "flex-end"}}> */}
                      {parseFloat(accounts[0]?.opening_balance || 0).toLocaleString(
                        "en-US",
                        {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }
                      )}
                      {/* </div> */}
                    </th>
                  </tr>
                  <tr style={{ borderBottom: "1px solid #d1d5db", }}>
                    <th style={{ padding: "8px", textAlign: "left", fontSize: 12 }}>ACCOUNT CODE</th>
                    <th style={{ padding: "8px", textAlign: "left", fontSize: 12 }}>ACCOUNT NAME</th>
                    <th style={{ padding: "8px", textAlign: "left", fontSize: 12 }}>TYPE</th>
                    {/* <th style={{ padding: "8px", textAlign: "left", fontSize: 12 }}></th> */}
                    <th style={{ padding: "8px", textAlign: "right", fontSize: 12, whiteSpace: 'wrap' }}>BEGINING BALANCE</th>
                    <th style={{ padding: "8px", textAlign: "right", fontSize: 12 }}>DEBIT</th>
                    <th style={{ padding: "8px", textAlign: "right", fontSize: 12 }}>CREDIT</th>
                    <th style={{ padding: "8px", textAlign: "right", fontSize: 12 }}>ENDING BALANCE</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(inputss) && inputss.length > 0 ? (
                    inputss.map((item, index) => {
                      // ✅ Declare variables here, before returning JSX
                      const obalance = parseFloat(item.opening_balance) || 0;
                      const nDebit = parseFloat(item.nDebit) || 0;
                      const nCredit = parseFloat(item.nCredit) || 0;
                      const cbalance = parseFloat(item.closing_balance) || 0;

                      return (
                        <tr key={index} style={{ borderBottom: "1px solid #d1d5db" }}>
                          <td style={{ padding: "8px", fontSize: 12, whiteSpace: "wrap" }}>
                            {item.code}
                          </td>
                          <td style={{ padding: "8px", fontSize: 12 }}>
                            {item.name}
                          </td>
                          <td
                            style={{
                              padding: "8px",
                              // whiteSpace: "normal",
                              fontSize: 12,
                            }}
                          >
                            {item.type}
                          </td>

                          {/* ✅ Opening Balance */}
                          <td
                            style={{
                              padding: "8px",
                              textAlign: "right",
                              // color: obalance > 0 ? "red" : "#111827",
                              fontSize: 12,
                            }}
                          >
                            {isNaN(obalance)
                              ? "0.00"
                              : obalance.toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                          </td>

                          {/* ✅ nDebit */}
                          <td style={{
                            padding: "8px",
                            textAlign: "right",
                            color: nDebit > 0 ? "red" : "#111827",
                            fontSize: 12,
                          }}>
                            {isNaN(nDebit)
                              ? "0.00"
                              : nDebit.toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                          </td>

                          {/* ✅ nCredit */}
                          <td style={{
                            padding: "8px",
                            textAlign: "right",
                            color: nCredit > 0 ? "green" : "#111827",
                            fontSize: 12,
                          }}>
                            {isNaN(nCredit)
                              ? "0.00"
                              : nCredit.toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                          </td>

                          {/* ✅ Closing Balance */}
                          <td style={{
                            padding: "8px",
                            textAlign: "right",
                            // color: cbalance > 0 ? "red" : "#111827",
                            fontSize: 12,
                          }}>
                            {isNaN(cbalance)
                              ? "0.00"
                              : cbalance.toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="7" style={{ textAlign: "center", padding: "16px" }}>
                        No accounts found
                      </td>
                    </tr>
                  )}
                </tbody>

                <tfoot>
                  {/* Empty spacer row above TOTALS */}
                  <tr>
                    <td colSpan="7" style={{ height: "30px", border: "none", background: "transparent" }}></td>
                  </tr>

                  <tr>
                    <td style={{ padding: "8px", fontWeight: 700, fontSize: 14 }}>TOTALS</td>
                    <td></td>
                    <td></td>
                    <td style={{ textAlign: 'right', fontWeight: "bold", fontSize: "14px", }}>{totalOpening}</td>
                    <td
                      style={{
                        textAlign: 'right',
                        fontWeight: "bold",
                         fontSize: "14px",
                        color: "red",
                      }}
                    >
                      {totalDebit}
                    </td>
                    <td
                      style={{
                        textAlign: 'right',
                        fontWeight: "bold",
                         fontSize: "14px",
                        color: "green",
                        paddingLeft: "15px"
                      }}
                    >
                      {totalCredit}
                    </td>
                    <td style={{ textAlign: 'right', fontWeight: "bold", fontSize: "14px", }}>{totalClosing}</td>
                  </tr>

                  {/* Empty spacer row between TOTALS and BALANCE */}
                  <tr>
                    <td colSpan="7" style={{ height: "20px", border: "none", background: "transparent" }}></td>
                  </tr>

                  {/* Add Balance Row - positioned under beginning balance, debit, and credit */}
                  <tr style={{ borderTop: "2px solid #d1d5db" }}>
                    <td style={{ padding: "8px", fontWeight: 700, fontSize: 14 }}>BALANCE</td>
                    <td></td>
                    <td></td>
                    <td style={{
                      textAlign: 'right',
                      fontWeight: "bold",
                      fontSize: "14px",
                      color: "#3B82F6"
                    }}>
                      {(() => {
                        const debitNum = parseFloat(totalDebit.replace(/,/g, '')) || 0;
                        const creditNum = parseFloat(totalCredit.replace(/,/g, '')) || 0;
                        const balance = debitNum - creditNum;

                        return balance.toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        });
                      })()}
                    </td>
                    <td style={{
                      textAlign: 'right',
                      fontWeight: "bold",
                       fontSize: "14px",
                      color: "#3B82F6"
                    }}>
                      {(() => {
                        const debitNum = parseFloat(totalDebit.replace(/,/g, '')) || 0;
                        const creditNum = parseFloat(totalCredit.replace(/,/g, '')) || 0;
                        const balance = debitNum - creditNum;

                        return balance.toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        });
                      })()}
                    </td>
                    <td style={{
                      textAlign: 'right',
                      fontWeight: "bold",
                       fontSize: "14px",
                      color: "#3B82F6"
                    }}>
                      {(() => {
                        const creditNum = parseFloat(totalCredit.replace(/,/g, '')) || 0;
                        const debitNum = parseFloat(totalDebit.replace(/,/g, '')) || 0;
                        const balance = creditNum - debitNum;

                        return balance.toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        });
                      })()}
                    </td>
                    <td style={{
                      textAlign: 'right',
                      fontWeight: "bold",
                       fontSize: "14px",
                      color: "#3B82F6"
                    }}>
                      {(() => {
                        const debitNum = parseFloat(totalDebit.replace(/,/g, '')) || 0;
                        const creditNum = parseFloat(totalCredit.replace(/,/g, '')) || 0;
                        const balance = debitNum - creditNum;

                        return balance.toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        });
                      })()}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </>
          )}
        </div>

      </div>





      {savingsLoading && (
        <div className={classes.overlay}>
          <img src={RotatingLogo} alt="Loading..." className={classes.spinnerLogo} />
        </div>
      )}

    </div>
  )
}
export default TrialBalance;


{/* <div style={{ marginTop: 27 }} /> */ }
{/* {accounts?.length > 0 && (
        <div className={classes.cardContainer}>
  {(() => {
    const openingBalance = parseFloat(accounts[0]?.opening_balance || 0);

  
    let totalDebit = 0;
    let totalCredit = 0;

    accounts.forEach((item) => {
      totalDebit += parseFloat(item.debit) || 0;
      totalCredit += parseFloat(item.credit) || 0;
    });

    const closingBalance = parseFloat(accounts[0]?.closing_balance || 0);

    const stats = [
      {
        label: "Opening Balance",
        value: openingBalance,
        labelColor: "#2563EB",
      },
      
      {
        label: "Total Debits",
        value: totalDebit,
        labelColor: "#EF4444",
      },
      {
        label: "Total Credits",
        value: totalCredit,
        labelColor: "#16A34A",
      },
      {
        label: "Closing Balance",
        value: closingBalance,
        labelColor: "#A855F7",
      },
    ];

    return stats.map((item, idx) => (
      <div className={classes.statCard} key={idx}>
       
        <h3 className={classes.cardValue}>
          <span style={{ color: item.labelColor }}>
            {item.value.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </span>
        </h3>

       
        <div className={classes.cardHeader}>
          <p className={classes.cardLabel}  style={{ color: item.labelColor }}>{item.label}</p>
        </div>
      </div>
    ));
  })()}
</div>
)} */}
